module.exports = __webpack_public_path__ + "static/media/vida-04.15951c4f.png";